export const gdprBannerContent = {
  en: {
    content:
      'We and our partners, including Google, use cookies and similar identifiers to measure our ads and to show personalized and non-personalized ads (ads personalization). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Learn how Google uses your data.</a>',
    acceptButtonCaption: 'Accept',
    rejectButtonCaption: 'Reject',
    customizeButtonCaption: 'Learn more and customize',
  },
  de: {
    content:
      'Wir und unsere Partner, einschließlich Google, verwenden Cookies und ähnliche Kennungen, um unsere Anzeigen zu messen und personalisierte und nicht personalisierte Anzeigen anzuzeigen (Personalisierung von Werbung). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Erfahren Sie, wie Google Ihre Daten verwendet.</a>',
    acceptButtonCaption: 'Akzeptieren',
    rejectButtonCaption: 'Ablehnen',
    customizeButtonCaption: 'Mehr erfahren und anpassen',
  },
  es: {
    content:
      'Nosotros y nuestros socios, incluido Google, usamos cookies e identificadores similares para medir nuestros anuncios y mostrar anuncios personalizados y no personalizados (personalización de anuncios). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Descubre cómo utiliza Google tus datos.</a>',
    acceptButtonCaption: 'Aceptar',
    rejectButtonCaption: 'Rechazar',
    customizeButtonCaption: 'Más información y personalizar',
  },
  fr: {
    content:
      'Nous et nos partenaires, dont Google, utilisons des cookies et des identifiants similaires pour mesurer nos annonces et afficher des annonces personnalisées et non personnalisées (personnalisation des annonces). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Découvrez comment Google utilise vos données.</a>',
    acceptButtonCaption: 'Accepter',
    rejectButtonCaption: 'Refuser',
    customizeButtonCaption: 'En savoir plus et personnaliser',
  },
  nl: {
    content:
      'Wij en onze partners, waaronder Google, gebruiken cookies en vergelijkbare identificatoren om onze advertenties te meten en gepersonaliseerde en niet-gepersonaliseerde advertenties te tonen (advertentiepersonalisatie). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Lees hoe Google je gegevens gebruikt.</a>',
    acceptButtonCaption: 'Accepteren',
    rejectButtonCaption: 'Weigeren',
    customizeButtonCaption: 'Meer informatie en aanpassen',
  },
  ms: {
    content:
      'Kami dan rakan kongsi kami, termasuk Google, menggunakan kuki dan pengecam yang serupa untuk mengukur iklan kami dan memaparkan iklan diperibadikan dan tidak diperibadikan (pemperibadian iklan). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Ketahui cara Google menggunakan data anda.</a>',
    acceptButtonCaption: 'Terima',
    rejectButtonCaption: 'Tolak',
    customizeButtonCaption: 'Ketahui lebih lanjut dan sesuaikan',
  },
  et: {
    content:
      'Meie ja meie partnerid, sealhulgas Google, kasutame küpsiseid ja sarnaseid identifikaatoreid oma reklaamide mõõtmiseks ning isikupärastatud ja isikupärastamata reklaamide näitamiseks (reklaamide isikupärastamine). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Vaadake, kuidas Google teie andmeid kasutab.</a>',
    acceptButtonCaption: 'Nõustu',
    rejectButtonCaption: 'Keeldu',
    customizeButtonCaption: 'Lisateave ja kohandamine',
  },
  it: {
    content:
      'Noi e i nostri partner, incluso Google, utilizziamo cookie e identificatori simili per misurare i nostri annunci e mostrare annunci personalizzati e non personalizzati (personalizzazione degli annunci). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Scopri come Google utilizza i tuoi dati.</a>',
    acceptButtonCaption: 'Accetta',
    rejectButtonCaption: 'Rifiuta',
    customizeButtonCaption: 'Scopri di più e personalizza',
  },
  lv: {
    content:
      'Mēs un mūsu partneri, tostarp Google, izmantojam sīkfailus un līdzīgus identifikatorus, lai novērtētu mūsu reklāmas un rādītu personalizētas un nepersonalizētas reklāmas (reklāmu personalizācija). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Uzziniet, kā Google izmanto jūsu datus.</a>',
    acceptButtonCaption: 'Pieņemt',
    rejectButtonCaption: 'Noraidīt',
    customizeButtonCaption: 'Uzzināt vairāk un pielāgot',
  },
  lt: {
    content:
      'Mes ir mūsų partneriai, įskaitant „Google“, naudojame slapukus ir panašius identifikatorius savo skelbimams vertinti ir suasmenintiems bei nesuasmenintiems skelbimams rodyti (skelbimų suasmeninimas). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Sužinokite, kaip „Google“ naudoja jūsų duomenis.</a>',
    acceptButtonCaption: 'Priimti',
    rejectButtonCaption: 'Atmesti',
    customizeButtonCaption: 'Sužinoti daugiau ir tinkinti',
  },
  pl: {
    content:
      'My i nasi partnerzy, w tym Google, używamy plików cookie i podobnych identyfikatorów do pomiaru naszych reklam oraz wyświetlania reklam spersonalizowanych i niespersonalizowanych (personalizacja reklam). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Dowiedz się, jak Google wykorzystuje Twoje dane.</a>',
    acceptButtonCaption: 'Akceptuj',
    rejectButtonCaption: 'Odrzuć',
    customizeButtonCaption: 'Dowiedz się więcej i dostosuj',
  },
  pt: {
    content:
      'Nós e nossos parceiros, incluindo o Google, usamos cookies e identificadores semelhantes para medir nossos anúncios e exibir anúncios personalizados e não personalizados (personalização de anúncios). <a href="https://business.safety.google/privacy/" target="_blank" rel="noopener noreferrer">Saiba como o Google usa seus dados.</a>',
    acceptButtonCaption: 'Aceitar',
    rejectButtonCaption: 'Rejeitar',
    customizeButtonCaption: 'Saiba mais e personalize',
  },
}
